import { TipoIstanzaFascicoloDTO } from "./tipo-istanza-fascicoloDTO";
import { ClassificaDTO } from "./classificaDTO";
import { StatoFascicoloEnum } from "../enum/stato-fascicolo-enum";
import { UtenteDTO } from "./utenteDTO";
import { RiferimentoEsternoDTO } from "./riferimento-esternoDTO";
import { CampoSpecificoFascicoloDTO } from "./campo-specifico-fascicoloDTO";
import { IstanzeProcedimentoDTO } from "./istanze-procedimentoDTO";
import { StrutturaFascicoloDTO } from "./struttura-fascicoloDTO";
import { CommentoDTO } from "./commentoDTO";
import { VisibilitaFascicoloDTO } from "./visibilita-fascicoloDTO";
import { AttivitaEreditataDTO } from "./procedimento-ereditatoDTO";
import { WrapperCollegamentoFascicoloDTO } from "./wrapper-collegamento-fascicoloDTO";
import { MetadatiRepertorioVO } from "../vo/metadati-repertorioVO";
import { DatiReportorioManualiDTO } from "./dati-repertorio-manualiDTO";
import { IstanzaAttivitaDTO } from "./istanza-attivitaDTO";

export class IperFascicoloDTO {
  id: string;

  tipologia: TipoIstanzaFascicoloDTO;

  oggetto: string;

  descrizione: string;

  classifica: ClassificaDTO;

  segnaturaArchivistica: string;

  stato: StatoFascicoloEnum;

  dataApertura: string;

  dataChiusura: string;

  dataAnnullamento: string;

  idFascicoliContenuti: string[];

  wrapperFascicoliContenuti: WrapperCollegamentoFascicoloDTO[];

  creatoDa: UtenteDTO;

  strutturaResponsabile: StrutturaFascicoloDTO;

  riferimentoFascicoloEsterno: RiferimentoEsternoDTO;

  attivitaAssociate: IstanzaAttivitaDTO;

  attivitaEreditate: AttivitaEreditataDTO[];

  campiSpecifici: CampoSpecificoFascicoloDTO[];

  referenteFascicolo: UtenteDTO;

  istanzeProcedimento: IstanzeProcedimentoDTO[];

  commenti: CommentoDTO[];

  visibilitaIperFascicolo: VisibilitaFascicoloDTO[];

  metadatiRepertorio: MetadatiRepertorioVO;

  datiRepertorioManuali: DatiReportorioManualiDTO;
}
